import Image from "@/components/Image";
import type { BasicTeam, Maybe } from "@/graphql/gql/graphql";
import styles from "./teamCellWithLocation.module.scss";

export type TeamCellWithLocationProps = {
  homeTeam?: Maybe<boolean>;
  opponentTeam: Pick<BasicTeam, "abbreviation" | "logoSVG">;
};

const TeamCellWithLocation = ({
  homeTeam,
  opponentTeam,
}: TeamCellWithLocationProps) => {
  const abbreviation = opponentTeam.abbreviation ?? "-";
  const logoSVG = opponentTeam.logoSVG ?? "";

  let location;
  if (homeTeam === undefined) {
    location = "-";
  } else {
    location = homeTeam ? "vs" : "@";
  }

  return (
    <div className={styles.cell}>
      <span className={styles.location}>{location}</span>
      <div className={styles.logoContainer}>
        <Image
          priority
          fill
          src={logoSVG ?? ""}
          alt={`${abbreviation} Team Logo`}
          sizes="17px"
        />
      </div>
      <span className={styles.teamName}>{abbreviation}</span>
    </div>
  );
};

export default TeamCellWithLocation;
